import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import posthog from 'posthog-js';
import { nullSafeGet, isAdminUser } from '../../utils/DataAccessUtils';
const { Content } = Layout;
const style = require('./FieldTechsOverviewPage.less');

class FieldTechsOverviewPage extends React.Component<any, any> {
	handleTabChange = (key) => {
		const { history } = this.props;
		history.push(`/supplier/fieldTechs/overview/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	render() {
		const { companyConfig, currentUser } = this.props;
		const isAdmin = isAdminUser(currentUser);
		const showWrenchMode = isAdmin && posthog.isFeatureEnabled('wrenchmode');
		const tabs = [
			{
				key: 'all',
				name: 'Overview',
			},
			...(showWrenchMode
				? [
						{
							key: 'wrenchModeLogs',
							name: 'Work Logs',
						},
				  ]
				: []),
		];

		return (
			<div>
				<ScrollToTopOnMount />
				<div>
					<Route
						path="/supplier/fieldTechs/overview"
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: '/supplier/fieldTechs/overview/all',
								}}
							/>
						)}
					/>
					<Content className="fieldTechsPage" style={{ padding: '0 0.5em' }}>
						<div
							style={{
								margin: '0 -8px',
								padding: '24px',
								paddingBottom: 0,
								background: nullSafeGet('detail.config.theme.navblock', companyConfig),
								marginBottom: 8,
							}}
						>
							<h4
								style={{
									color: 'rgba(255, 255, 255, 0.9)',
									marginRight: 8,
									marginBottom: 24,
								}}
							>
								Field Technicians
							</h4>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
						</div>
						{this.props.childRoutes.map((r, i) => (
							<RouteWithSubRoutes key={i} {...r} />
						))}
					</Content>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(FieldTechsOverviewPage)
);
